import React from "react";
import { Button } from "reactstrap";

export const renderStatus = (status) => {
  const statusStyles = {
    Pending: {
      bg: "#FDECEC",
      color: "#E53935",
      icon: "ri-close-circle-fill",
    },
    "Waiting Approval": {
      bg: "#FFF8E1",
      color: "#F9A825",
      icon: "ri-error-warning-fill",
    },
    Approved: {
      bg: "#E8F5E9",
      color: "#2E7D32",
      icon: "ri-checkbox-circle-fill",
    },
    Completed: {
      bg: "#E8F5E9",
      color: "#2E7D32",
      icon: "ri-checkbox-circle-fill",
    },
  };

  const style = statusStyles[status];

  return (
    <span
      style={{
        background: style?.bg,
        color: style?.color,
        padding: "4px 8px",
        fontSize: "13px",
        fontWeight: 500,
        display: "inline-flex",
        alignItems: "center",
        borderRadius: "4px",
      }}
    >
      <i className={`${style?.icon} me-1`} />
      {status}
    </span>
  );
};

const actionStyles = {
  stockout: {
    bg: "#FF8A50",
    color: "#fff",
    icon: "ri-download-2-line",
    label: "Stock Out",
    permission: "stockout",
  },
  request: {
    bg: "#FF8A50",
    color: "#fff",
    icon: "ri-checkbox-circle-line",
    label: "Request Approval",
    permission: "notification",
  },
  approve: {
    bg: "#FF8A50",
    color: "#fff",
    icon: "ri-check-double-line",
    label: "Approval Pending",
    permission: "approve",
  },
  completed: {
    bg: "#FF8A50",
    color: "#fff",
    icon: "ri-download-2-line",
    label: "Stock Out",
    permission: "stockout",
    disabled: true,
  },
};

export function SOActionButton({
  action,
  rowData,
  parentRow,
  salesorderPermission,
  onRequest,
  onApprove,
  onStockOut,
}) {
  const style = actionStyles[action];

  if (!style || !salesorderPermission?.has(style.permission)) {
    return (
      <span
        style={{
          display: "inline-block",
          minWidth: "70px",
          textAlign: "center",
          color: "#999",
          fontWeight: 500,
        }}
      >
        --
      </span>
    );
  }

  const handleClick = () => {
    if (style?.disabled) return;
    if (action === "request") onRequest?.();
    if (action === "approve") onApprove?.();
    if (action === "stockout") onStockOut?.();
  };

  return (
    <Button
      size="sm"
      onClick={handleClick}
      style={{
        background: style?.bg,
        color: style?.color,
        border: "none",
        borderRadius: "4px",
        padding: "6px 8px",
        fontSize: "13px",
        fontWeight: 500,
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        opacity: style?.disabled ? 0.8 : 1,
        cursor: style?.disabled ? "not-allowed" : "pointer",
      }}
    >
      <i className={style?.icon}></i>
      {style?.label}
    </Button>
  );
}